import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchCountData } from '../../redux/slices/countSlice';
import './counter.scss';

const getDigits = (number) => {
  return Array.from({ length: number }, (_, i) => i);
};

const ItemOfCounter = ({ item, index }) => {
  const [currentNumber, setCurrentNumber] = useState(0);
  const [isChanged, setIsChanged] = useState(false);

  useEffect(() => {
    if (currentNumber !== item) {
      setIsChanged(true);
      setCurrentNumber(item);
    } else {
      setTimeout(() => {
        setIsChanged(false);
      }, 4000);
    }
  }, [item, currentNumber]);

  return (
    <div
      className={`digit-strip__wrapper ${isChanged ? 'active' : ''} digit-field`}
      style={{
        '--animationDelay': `${0.5 * index}s`,
        '--translateY': `-${32 * item}px`,
        '--itemWidth': `32px`,
      }}
    >
      <div className="digit-strip">
        {getDigits(10).map((digit) => (
          <div key={digit}>{digit}</div>
        ))}
      </div>
    </div>
  );
};

const CounterBody = ({ counter }) => {
  const arr = Array.from(String(counter), Number);

  return (
    <div className="numbers-field">
      {arr.map((item, i) => (
        <ItemOfCounter item={item} index={i} key={i} />
      ))}
    </div>
  );
};

const Counter = () => {
  const { survey_count, loading, success, failed } = useSelector(
    (s) => s.count,
  );
  const counterBlockRef = useRef(null);
  const [isInView, setIsInView] = useState(true);
  const [counter, setCounter] = useState(survey_count);
  const dispatch = useDispatch();

  // watch the counter on the screen
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsInView(entry.isIntersecting);
      },
      {
        threshold: 0.5,
      },
    );

    if (counterBlockRef.current) {
      observer.observe(counterBlockRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    let currentCounter = 0;

    if (!loading && !success && !failed && survey_count === currentCounter) {
      onFetchCounter();
    }

    if (survey_count > currentCounter) {
      setCounter(survey_count);
      currentCounter = survey_count;
    }

    const intervalId = setInterval(onFetchCounter, 10000);

    return () => clearInterval(intervalId);
  }, [loading, success, failed, survey_count, isInView]);

  const onFetchCounter = () => {
    if (isInView) dispatch(fetchCountData());
  };

  return (
    <div className="counter-wrapper" ref={counterBlockRef}>
      {loading && counter === 0 ? (
        <div className="counter__loader">
          {getDigits(4).map((digit) => (
            <div key={digit} className="digit-field" />
          ))}
        </div>
      ) : (
        <div className="counter">
          {counter > 0 && <CounterBody counter={counter} />}
        </div>
      )}
      <div className="counter__label">
        <span>Estimated </span> Successful Reports
      </div>
    </div>
  );
};

export default Counter;
